var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.printPDF()}}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":_vm.color}},on),[_vm._v(_vm._s(_vm.icon))])]}}])},[_c('span',[_vm._v("Print Label")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }